import { gql } from 'graphql-tag';
export const PRODUCTPUBLISHSETTING_FIELDS_FRAGMENT = gql `
  fragment ProductPublishSettingFields on ProductPublishSetting {

    activateOnAccept
    publishOnlineOnAccept
  }
`;
export const SELLERLOCATIONSETTING_FIELDS_FRAGMENT = gql `
  fragment SellerLocationSettingFields on SellerLocationSetting {

    hideSelectCountryIfSingleCountry
    sellerLocationOption
    allowedCountries
  }
`;
export const PRODUCTSHIPPINGSETTING_FIELDS_FRAGMENT = gql `
  fragment ProductShippingSettingFields on ProductShippingSetting {

    allowProfiles
    inlineShippingOptions
    shippingCountryOfOriginOption
    customShippingCountryOfOriginList
    hideSelectCountryIfSingleCountry
    allowAllInternationalShippingCountries
    allowedInternationalShippingCountries
  }
`;
export const PRODUCTTYPESETTING_FIELDS_FRAGMENT = gql `
  fragment ProductTypeSettingFields on ProductTypeSetting {

    productType
  }
`;
export const STOREFRONTSETTING_FIELDS_FRAGMENT = gql `
  fragment StorefrontSettingFields on StorefrontSetting {

    enabled
    storefrontOptions {
      allowNotification
      allowBanner
      allowStory
      allowOwnerBio
      allowReviews
      allowMessaging
    }
  }
`;
export const SELLERORDERACCEPTSETTING_FIELDS_FRAGMENT = gql `
  fragment SellerOrderAcceptSettingFields on SellerOrderAcceptSetting {

    autoAccept
    orderAcceptTimeout
  }
`;
export const SELLERORDERFEESETTING_FIELDS_FRAGMENT = gql `
  fragment SellerOrderFeeSettingFields on SellerOrderFeeSetting {

    orderFee
  }
`;
export const SELLERORDERFULFILLEDSETTING_FIELDS_FRAGMENT = gql `
  fragment SellerOrderFulfilledSettingFields on SellerOrderFulfilledSetting {

    autoFulfilled
    orderFulfilledTimeout
  }
`;
export const PAYOUTPERIODSETTING_FIELDS_FRAGMENT = gql `
  fragment PayoutPeriodSettingFields on PayoutPeriodSetting {

    payoutPeriod
    payoutPeriodChoice
  }
`;
export const PRODUCTFEESETTING_FIELDS_FRAGMENT = gql `
  fragment ProductFeeSettingFields on ProductFeeSetting {

    productFee
  }
`;
export const PRODUCTPERCENTAGESETTING_FIELDS_FRAGMENT = gql `
  fragment ProductPercentageSettingFields on ProductPercentageSetting {

    productPercentage
  }
`;
export const RETURNSSETTING_FIELDS_FRAGMENT = gql `
  fragment ReturnsSettingFields on ReturnsSetting {

    noReturns
    returnsTimeout
  }
`;
export const SHIPPINGPERCENTAGESETTING_FIELDS_FRAGMENT = gql `
  fragment ShippingPercentageSettingFields on ShippingPercentageSetting {

    shippingPercentage
  }
`;
export const PRODUCTREVIEWSETTING_FIELDS_FRAGMENT = gql `
  fragment ProductReviewSettingFields on ProductReviewSetting {

    reviewAction
  }
`;
export const SETTINGS_FRAGMENT = gql `
  fragment SettingsFragment on ShopSettings {
    productPublish {
      ...ProductPublishSettingFields
    }
    sellerLocation {
      ...SellerLocationSettingFields
    }
    productShipping {
      ...ProductShippingSettingFields
    }
    productType {
      ...ProductTypeSettingFields
    }
    storefront {
      ...StorefrontSettingFields
    }
    sellerOrderAccept {
      ...SellerOrderAcceptSettingFields
    }
    orderFee {
      ...SellerOrderFeeSettingFields
    }
    sellerOrderFulfilled {
      ...SellerOrderFulfilledSettingFields
    }
    payoutPeriod {
      ...PayoutPeriodSettingFields
    }
    productFee {
      ...ProductFeeSettingFields
    }
    productPercentage {
      ...ProductPercentageSettingFields
    }
    returns {
      ...ReturnsSettingFields
    }
    shippingPercentage {
      ...ShippingPercentageSettingFields
    }
    productReview {
      ...ProductReviewSettingFields
    }
  }
  ${PRODUCTPUBLISHSETTING_FIELDS_FRAGMENT}
  ${SELLERLOCATIONSETTING_FIELDS_FRAGMENT}
  ${PRODUCTSHIPPINGSETTING_FIELDS_FRAGMENT}
  ${PRODUCTTYPESETTING_FIELDS_FRAGMENT}
  ${STOREFRONTSETTING_FIELDS_FRAGMENT}
  ${SELLERORDERACCEPTSETTING_FIELDS_FRAGMENT}
  ${SELLERORDERFEESETTING_FIELDS_FRAGMENT}
  ${SELLERORDERFULFILLEDSETTING_FIELDS_FRAGMENT}
  ${PAYOUTPERIODSETTING_FIELDS_FRAGMENT}
  ${PRODUCTFEESETTING_FIELDS_FRAGMENT}
  ${PRODUCTPERCENTAGESETTING_FIELDS_FRAGMENT}
  ${RETURNSSETTING_FIELDS_FRAGMENT}
  ${SHIPPINGPERCENTAGESETTING_FIELDS_FRAGMENT}
  ${PRODUCTREVIEWSETTING_FIELDS_FRAGMENT}
`;
export const SELLER_SETTINGS_FRAGMENT = gql `
  fragment SellerSettingsFragment on SellerSettings {
    productPublish {
      ...ProductPublishSettingFields
    }
    sellerLocation {
      ...SellerLocationSettingFields
    }
    productShipping {
      ...ProductShippingSettingFields
    }
    productType {
      ...ProductTypeSettingFields
    }
    storefront {
      ...StorefrontSettingFields
    }
    sellerOrderAccept {
      ...SellerOrderAcceptSettingFields
    }
    orderFee {
      ...SellerOrderFeeSettingFields
    }
    sellerOrderFulfilled {
      ...SellerOrderFulfilledSettingFields
    }
    payoutPeriod {
      ...PayoutPeriodSettingFields
    }
    productFee {
      ...ProductFeeSettingFields
    }
    productPercentage {
      ...ProductPercentageSettingFields
    }
    returns {
      ...ReturnsSettingFields
    }
    shippingPercentage {
      ...ShippingPercentageSettingFields
    }
    productReview {
      ...ProductReviewSettingFields
    }
  }
  ${PRODUCTPUBLISHSETTING_FIELDS_FRAGMENT}
  ${SELLERLOCATIONSETTING_FIELDS_FRAGMENT}
  ${PRODUCTSHIPPINGSETTING_FIELDS_FRAGMENT}
  ${PRODUCTTYPESETTING_FIELDS_FRAGMENT}
  ${STOREFRONTSETTING_FIELDS_FRAGMENT}
  ${SELLERORDERACCEPTSETTING_FIELDS_FRAGMENT}
  ${SELLERORDERFEESETTING_FIELDS_FRAGMENT}
  ${SELLERORDERFULFILLEDSETTING_FIELDS_FRAGMENT}
  ${PAYOUTPERIODSETTING_FIELDS_FRAGMENT}
  ${PRODUCTFEESETTING_FIELDS_FRAGMENT}
  ${PRODUCTPERCENTAGESETTING_FIELDS_FRAGMENT}
  ${RETURNSSETTING_FIELDS_FRAGMENT}
  ${SHIPPINGPERCENTAGESETTING_FIELDS_FRAGMENT}
  ${PRODUCTREVIEWSETTING_FIELDS_FRAGMENT}
`;
export const PRODUCT_SETTINGS_FRAGMENT = gql `
  fragment ProductSettingsFragment on ProductSettings {
    productFee {
      ...ProductFeeSettingFields
    }
    productPercentage {
      ...ProductPercentageSettingFields
    }
    returns {
      ...ReturnsSettingFields
    }
    shippingPercentage {
      ...ShippingPercentageSettingFields
    }
    productReview {
      ...ProductReviewSettingFields
    }
  }
  ${PRODUCTFEESETTING_FIELDS_FRAGMENT}
  ${PRODUCTPERCENTAGESETTING_FIELDS_FRAGMENT}
  ${RETURNSSETTING_FIELDS_FRAGMENT}
  ${SHIPPINGPERCENTAGESETTING_FIELDS_FRAGMENT}
  ${PRODUCTREVIEWSETTING_FIELDS_FRAGMENT}
`;
//# sourceMappingURL=fragments.js.map